// source https://stackoverflow.com/a/37511463
export const removeDiacritics = (str: string): string =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')



// WEBPACK FOOTER //
// ./src/helpers/text.ts